import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/Documentation/Documentation/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "help-and-support"
    }}>{`Help and Support`}</h3>
    <h3 {...{
      "id": "where-to-get-support"
    }}>{`Where to Get Support?`}</h3>
    <p>{`If you're reporting a bug, or you have a feature request, you can use GitHub
issues: `}<a parentName="p" {...{
        "href": "https://github.com/Cezerin3/Store/issues"
      }}>{`https://github.com/Cezerin3/Store/issues`}</a></p>
    <p>{`If you need some help with deployment and something does not quite work, message
on:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://cezerin.org"
          }}><strong parentName="a">{`Cezerin Community Site`}</strong></a>{`: `}<a parentName="p" {...{
            "href": "https://cezerin.org"
          }}>{`https://cezerin.org`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://github.com/Cezerin3/Store/issues"
          }}><strong parentName="a">{`GitHub Issues`}</strong></a>{`:
`}<a parentName="p" {...{
            "href": "https://github.com/Cezerin3/Store/issues"
          }}>{`https://github.com/Cezerin3/Store/issues`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://t.me/cezerin"
          }}><strong parentName="a">{`Telegram Chat: Cezerin`}</strong></a>{`: `}<a parentName="p" {...{
            "href": "https://t.me/cezerin"
          }}>{`https://t.me/cezerin`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://groups.google.com/g/cezerin"
          }}><strong parentName="a">{`Google Groups Forum`}</strong></a>{`:
`}<a parentName="p" {...{
            "href": "https://groups.google.com/g/cezerin"
          }}>{`https://groups.google.com/g/cezerin`}</a></p>
      </li>
    </ul>
    <h3 {...{
      "id": "need-private-support"
    }}>{`Need Private Support?`}</h3>
    <p>{`For a basic installation on windows can be asked at issues section and will be
done in teamviewer...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      